import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/customer'
import {format} from 'utils'

export async function search(params) {
    return request(api.search.url, {
        method: api.search.type,
        body: params,
    })
}

export async function detail(payload) {
    return request(`${format(api.detail.url, {id: payload.id})}?${stringify(payload.params)}`)
}

export async function syncStatus() {
    return request(api.syncStatus.url)
}

export async function manualSync() {
    return request(api.manualSync.url, {
        method: api.manualSync.type,
    })
}

export async function exportTaskId(payload) {
    return request(api.exportTaskId.url, {
        method: api.exportTaskId.type,
        body: payload.body,
    })
}

export async function exportMCTaskId(payload) {
    return request(api.exportMCTaskId.url, {
        method: api.exportMCTaskId.type,
        body: payload.body,
    })
}

export async function exportTopToyTaskId(payload) {
    return request(api.exportTopToyTaskId.url, {
        method: api.exportTopToyTaskId.type,
        body: payload.body,
    })
}
